import styled from "styled-components"

const Img = styled.img`
  position: fixed;
  bottom: 0;
  left: 0;
`;

export const BgDollars = () => {
    return (
        <></>
    )
}